// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';


// const API_BASE = 'https://api.lionsmd320.org/admin/api/api';

// export default function PublicFormView({ formIdProp }) {
//   const { formId: routeFormId } = useParams() || {};
//   const formId = formIdProp || routeFormId;

//   const [formSchema, setFormSchema] = useState([]);
//   const [formTitle, setFormTitle] = useState('');
//   const [formData, setFormData] = useState({});
//   const [fileData, setFileData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [submitted, setSubmitted] = useState(false);
//   const [errorMsg, setErrorMsg] = useState('');

//   useEffect(() => {
//     const fetchFormStructure = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/public/form/${formId}`);
//         if (res.data.success) {
//           setFormTitle(res.data.title);
//           setFormSchema(res.data.schema);
//         }
//       } catch (err) {
//         setErrorMsg('Invalid or expired form link.');
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (formId) fetchFormStructure();
//   }, [formId]);

//   const handleInputChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//   };

//   const handleFileChange = (field, file) => {
//     setFileData({ ...fileData, [field]: file });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const payload = new FormData();

//     Object.keys(formData).forEach(key => payload.append(key, formData[key]));
//     Object.keys(fileData).forEach(key => payload.append(key, fileData[key]));

//     try {
//       const res = await axios.post(`${API_BASE}/public/form/${formId}/submit`, payload, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });
//       if (res.data.success) setSubmitted(true);
//     } catch (err) {
//       alert('Form submission failed.');
//     }
//   };

//   if (loading) return <div style={{ color: '#fff', padding: '40px', textAlign: 'center' }}>Loading form...</div>;
//   if (errorMsg) return <div style={{ color: '#ef4444', padding: '40px', textAlign: 'center' }}>{errorMsg}</div>;
//   if (submitted) return (
//     <div style={{ backgroundColor: '#090d16', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <div style={{ backgroundColor: '#0f172a', padding: '30px', borderRadius: '12px', border: '1px solid #1e293b', textAlign: 'center', color: '#fff' }}>
//         <h2 style={{ color: '#34d399' }}>Response Submitted!</h2>
//         <p style={{ color: '#94a3b8', fontSize: '14px' }}>Your submission has been recorded in the database.</p>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{ backgroundColor: '#090d16', minHeight: '100vh', padding: '24px 12px', fontFamily: 'sans-serif' }}>
//       <div style={{ maxWidth: '640px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '16px' }}>

//         {/* Form Title Banner */}
//         <div style={{ backgroundColor: '#0f172a', borderTop: '8px solid #0891b2', borderRadius: '12px', padding: '24px', borderLeft: '1px solid #1e293b', borderRight: '1px solid #1e293b', borderBottom: '1px solid #1e293b' }}>
//           <h1 style={{ color: '#f8fafc', fontSize: '24px', margin: 0 }}>{formTitle}</h1>
//           <p style={{ color: '#94a3b8', fontSize: '12px', marginTop: '8px' }}>Please fill in the required dynamic fields below.</p>
//         </div>

//         <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//           {/* {formSchema.map((field) => {
//             const isImage = field.Type.toLowerCase().includes('varchar') && field.Field.toLowerCase().includes('image');

//             return (
//               <div key={field.Field} style={{ backgroundColor: '#0f172a', border: '1px solid #1e293b', borderRadius: '12px', padding: '20px' }}>
//                 <label style={{ color: '#f1f5f9', fontSize: '14px', fontWeight: '500', display: 'block', marginBottom: '10px' }}>
//                   {field.Field} {field.Null === 'NO' && <span style={{ color: '#ef4444' }}>*</span>}
//                 </label>

//                 {isImage ? (
//                   <input
//                     type="file"
//                     accept="image/*"
//                     required={field.Null === 'NO'}
//                     onChange={(e) => handleFileChange(field.Field, e.target.files[0])}
//                     style={{ color: '#94a3b8', fontSize: '13px' }}
//                   />
//                 ) : field.Type.toLowerCase().includes('text') ? (
//                   <textarea
//                     required={field.Null === 'NO'}
//                     onChange={(e) => handleInputChange(field.Field, e.target.value)}
//                     style={{ width: '100%', backgroundColor: '#020617', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', minHeight: '80px', boxSizing: 'border-box' }}
//                   />
//                 ) : (
//                   <input
//                     type={field.Type.toLowerCase().includes('int') ? 'number' : field.Type.toLowerCase().includes('date') ? 'date' : 'text'}
//                     required={field.Null === 'NO'}
//                     onChange={(e) => handleInputChange(field.Field, e.target.value)}
//                     style={{ width: '100%', backgroundColor: '#020617', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', boxSizing: 'border-box' }}
//                   />
//                 )}
//               </div>
//             );
//           })} */}


// {formSchema.map((field) => {
//   const fieldNameLower = field.Field.toLowerCase();

//   // Check if the column name contains image, photo, pic, profile, or avatar
//   const isImage = 
//     fieldNameLower.includes('image') || 
//     fieldNameLower.includes('photo') || 
//     fieldNameLower.includes('pic') || 
//     fieldNameLower.includes('profile');

//   return (
//     <div key={field.Field} style={{ backgroundColor: '#0f172a', border: '1px solid #1e293b', borderRadius: '12px', padding: '20px' }}>
//       <label style={{ color: '#f1f5f9', fontSize: '14px', fontWeight: '500', display: 'block', marginBottom: '10px' }}>
//         {field.Field} {field.Null === 'NO' && <span style={{ color: '#ef4444' }}>*</span>}
//       </label>

//       {isImage ? (
//         <input
//           type="file"
//           accept="image/*"
//           required={field.Null === 'NO'}
//           onChange={(e) => handleFileChange(field.Field, e.target.files[0])}
//           style={{ color: '#94a3b8', fontSize: '13px' }}
//         />
//       ) : field.Type.toLowerCase().includes('text') ? (
//         <textarea
//           required={field.Null === 'NO'}
//           onChange={(e) => handleInputChange(field.Field, e.target.value)}
//           style={{ width: '100%', backgroundColor: '#020617', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', minHeight: '80px', boxSizing: 'border-box' }}
//         />
//       ) : (
//         <input
//           type={field.Type.toLowerCase().includes('int') ? 'number' : field.Type.toLowerCase().includes('date') ? 'date' : 'text'}
//           required={field.Null === 'NO'}
//           onChange={(e) => handleInputChange(field.Field, e.target.value)}
//           style={{ width: '100%', backgroundColor: '#020617', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', boxSizing: 'border-box' }}
//         />
//       )}
//     </div>
//   );
// })}
//           <button type="submit" style={{ backgroundColor: '#0891b2', color: '#020617', border: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' }}>
//             Submit Response
//           </button>
//         </form>

//       </div>
//     </div>
//   );
// }




















// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';
// import { CheckCircle2, AlertCircle, ShieldCheck } from 'lucide-react';
// import logoImage from '../MD 320 LOGO.jpg';

// const API_BASE = 'https://api.lionsmd320.org/admin/api/api';
// const API_BASEDIST = 'https://api.lionsmd320.org/pages/api'; // Fixed typo from 'localhoost'

// export default function PublicFormView({ formIdProp }) {
//   const { formId: routeFormId } = useParams() || {};
//   const formId = formIdProp || routeFormId;

//   const [formSchema, setFormSchema] = useState([]);
//   const [formTitle, setFormTitle] = useState('');
//   const [districtsList, setDistrictsList] = useState([]);
//   const [formData, setFormData] = useState({});
//   const [fileData, setFileData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [submitted, setSubmitted] = useState(false);
//   const [errorMsg, setErrorMsg] = useState('');

//   // Fetch form structure and districts data independently on mount
//   useEffect(() => {
//     const fetchPortalData = async () => {
//       if (!formId) {
//         setErrorMsg('No form reference link provided.');
//         setLoading(false);
//         return;
//       }

//       // 1. Fetch Form Structure (Critical)
//       try {
//         const formRes = await axios.get(`${API_BASE}/public/form/${formId}`);
//         if (formRes.data && formRes.data.success) {
//           setFormTitle(formRes.data.title);
//           setFormSchema(formRes.data.schema);
//         } else {
//           setErrorMsg('Invalid or expired form reference link.');
//           setLoading(false);
//           return;
//         }
//       } catch (err) {
//         setErrorMsg('Invalid or expired form reference link.');
//         setLoading(false);
//         return;
//       }

//       // 2. Fetch Districts List (Non-critical / Independent)
//       try {
//         const districtRes = await axios.get(`${API_BASEDIST}/districtss`);
//         if (districtRes.data && districtRes.data.districts) {
//           setDistrictsList(districtRes.data.districts);
//         }
//       } catch (districtErr) {
//         console.warn('Could not fetch districts list, falling back gracefully:', districtErr);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPortalData();
//   }, [formId]);

//   const handleInputChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//   };

//   const handleFileChange = (field, file) => {
//     setFileData({ ...fileData, [field]: file });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const payload = new FormData();

//     Object.keys(formData).forEach(key => payload.append(key, formData[key]));
//     Object.keys(fileData).forEach(key => payload.append(key, fileData[key]));

//     try {
//       const res = await axios.post(`${API_BASE}/public/form/${formId}/submit`, payload, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });
//       if (res.data.success) setSubmitted(true);
//     } catch (err) {
//       alert('Form submission failed. Please check inputs and try again.');
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ backgroundColor: '#f1f5f9', color: '#475569', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
//         Loading official form portal...
//       </div>
//     );
//   }

//   if (errorMsg) {
//     return (
//       <div style={{ backgroundColor: '#f1f5f9', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', padding: '32px', borderRadius: '6px', textAlign: 'center', maxWidth: '450px', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
//           <div style={{ color: '#dc2626', marginBottom: '12px' }}><AlertCircle size={32} style={{ margin: '0 auto' }} /></div>
//           <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#1e293b', margin: '0 0 8px' }}>Service Unavailable</h2>
//           <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>{errorMsg}</p>
//         </div>
//       </div>
//     );
//   }

//   if (submitted) {
//     return (
//       <div style={{ backgroundColor: '#f1f5f9', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', padding: '40px 32px', borderRadius: '6px', textAlign: 'center', maxWidth: '480px', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
//           <div style={{ color: '#16a34a', marginBottom: '12px' }}><CheckCircle2 size={38} style={{ margin: '0 auto' }} /></div>
//           <h2 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1e293b', margin: '0 0 8px' }}>Submission Successful</h2>
//           <p style={{ fontSize: '13px', color: '#64748b', margin: 0, lineHeight: '1.5' }}>Your response has been securely registered in the central database system.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{ backgroundColor: '#f1f5f9', color: '#1e293b', minHeight: '100vh', padding: '30px 16px', fontFamily: 'Arial, Helvetica, sans-serif' }}>
//       <div style={{ maxWidth: '720px', margin: '0 auto', backgroundColor: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '8px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', overflow: 'hidden' }}>

//         {/* Official Portal Header Banner with Logo */}
//         <div style={{ backgroundColor: '#1e3a8a', color: '#ffffff', padding: '20px 24px', borderBottom: '4px solid #f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
//           <div>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
//               <ShieldCheck size={16} color="#f59e0b" />
//               <span style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 'bold', color: '#93c5fd' }}>Official Online Submission Portal</span>
//             </div>
//             <h1 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0, letterSpacing: '-0.01em' }}>{formTitle}</h1>
//             <p style={{ fontSize: '12px', color: '#cbd5e1', margin: '6px 0 0' }}>Fields marked with an asterisk (<span style={{ color: '#f87171' }}>*</span>) are mandatory.</p>
//           </div>

//           <div style={{ backgroundColor: '#ffffff', padding: '6px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', flexShrink: 0 }}>
//             <img src={logoImage} alt="Portal Logo" style={{ height: '48px', width: 'auto', display: 'block', objectFit: 'contain' }} />
//           </div>
//         </div>

//         {/* Main Form Body */}
//         <form onSubmit={handleSubmit} style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>

//           {formSchema.map((field) => {
//             const fieldNameLower = field.Field.toLowerCase();
//             const isImage =
//               fieldNameLower.includes('image') ||
//               fieldNameLower.includes('photo') ||
//               fieldNameLower.includes('pic') ||
//               fieldNameLower.includes('profile');

//             const isDistrict = fieldNameLower.includes('district');

//             return (
//               <div key={field.Field} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                 <label style={{ color: '#0f172a', fontSize: '13px', fontWeight: 'bold', textAlign: 'left' }}>
//                   {field.Field} {field.Null === 'NO' && <span style={{ color: '#dc2626', marginLeft: '2px' }}>*</span>}
//                 </label>

//                 {isImage ? (
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                     <input
//                       type="file"
//                       accept="image/*"
//                       required={field.Null === 'NO'}
//                       onChange={(e) => handleFileChange(field.Field, e.target.files[0])}
//                       style={{ color: '#334155', fontSize: '13px', padding: '8px', border: '1px solid #94a3b8', borderRadius: '4px', backgroundColor: '#f8fafc', cursor: 'pointer', width: '100%', boxSizing: 'border-box' }}
//                     />
//                     <span style={{ fontSize: '11px', color: '#64748b' }}>Allowed formats: JPG, PNG, JPEG</span>
//                   </div>
//                 ) : isDistrict ? (
//                   <select
//                     required={field.Null === 'NO'}
//                     onChange={(e) => handleInputChange(field.Field, e.target.value)}
//                     style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid #94a3b8', color: '#0f172a', padding: '9px 12px', borderRadius: '4px', boxSizing: 'border-box', fontSize: '13px', outline: 'none' }}
//                     onFocus={(e) => e.target.style.borderColor = '#1e3a8a'}
//                     onBlur={(e) => e.target.style.borderColor = '#94a3b8'}
//                   >
//                     <option value="">-- Select District --</option>
//                     {districtsList.map((d, index) => (
//                       <option key={index} value={d.district_name}>
//                         {d.district_name}
//                       </option>
//                     ))}
//                   </select>
//                 ) : field.Type.toLowerCase().includes('text') ? (
//                   <textarea
//                     required={field.Null === 'NO'}
//                     placeholder={`Enter details for ${field.Field.toLowerCase()}...`}
//                     onChange={(e) => handleInputChange(field.Field, e.target.value)}
//                     style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid #94a3b8', color: '#0f172a', padding: '10px 12px', borderRadius: '4px', minHeight: '90px', boxSizing: 'border-box', fontSize: '13px', outline: 'none' }}
//                     onFocus={(e) => e.target.style.borderColor = '#1e3a8a'}
//                     onBlur={(e) => e.target.style.borderColor = '#94a3b8'}
//                   />
//                 ) : (
//                   <input
//                     type={field.Type.toLowerCase().includes('int') ? 'number' : field.Type.toLowerCase().includes('date') ? 'date' : 'text'}
//                     required={field.Null === 'NO'}
//                     placeholder={`Enter ${field.Field.toLowerCase()}...`}
//                     onChange={(e) => handleInputChange(field.Field, e.target.value)}
//                     style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid #94a3b8', color: '#0f172a', padding: '9px 12px', borderRadius: '4px', boxSizing: 'border-box', fontSize: '13px', outline: 'none' }}
//                     onFocus={(e) => e.target.style.borderColor = '#1e3a8a'}
//                     onBlur={(e) => e.target.style.borderColor = '#94a3b8'}
//                   />
//                 )}
//               </div>
//             );
//           })}

//           <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '16px', display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
//             <button
//               type="submit"
//               style={{ backgroundColor: '#1e3a8a', color: '#ffffff', border: 'none', padding: '10px 24px', borderRadius: '4px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', letterSpacing: '0.02em', textTransform: 'uppercase' }}
//               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
//               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1e3a8a'}
//             >
//               Submit Application
//             </button>
//           </div>

//         </form>

//       </div>
//     </div>
//   );
// }
















import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  CheckCircle2,
  AlertCircle,
  ShieldCheck
} from 'lucide-react';

import logoImage from '../MD 320 LOGO.jpg';

const API_BASE = 'https://api.lionsmd320.org/admin/api/api';
const API_BASEDIST = 'https://api.lionsmd320.org/pages/api';

export default function PublicFormView({ formIdProp }) {

  const { formId: routeFormId, userId: routeUserId } = useParams();
  const [searchParams] = useSearchParams();
  const formId = formIdProp || routeFormId;
  const userId = searchParams.get('user_id') || routeUserId;
  const [formSchema, setFormSchema] = useState([]);
  const [formTitle, setFormTitle] = useState('');
  const [districtsList, setDistrictsList] = useState([]);
  const [formData, setFormData] = useState({});
  const [fileData, setFileData] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const fetchPortalData = async () => {
      if (!formId) {
        setErrorMsg('No form reference link provided.');
        setLoading(false);
        return;
      }

      try {
        const formRes = await axios.get(`${API_BASE}/public/form/${formId}`);

        if (formRes.data && formRes.data.success) {
          setFormTitle(formRes.data.title);
          setFormSchema(formRes.data.schema);
        } else {
          setErrorMsg('Invalid or expired form reference link.');
          setLoading(false);
          return;
        }
      } catch (err) {
        console.error('Form fetch error:', err);
        setErrorMsg('Invalid or expired form reference link.');
        setLoading(false);
        return;
      }

      try {
        // Fetch Districts List
        const districtRes = await axios.get(`${API_BASEDIST}/districtss`);
        if (districtRes.data && districtRes.data.districts) {
          setDistrictsList(districtRes.data.districts);
        }
      } catch (districtErr) {
        console.warn('Could not fetch districts:', districtErr);
      } finally {
        setLoading(false);
      }
    };

    fetchPortalData();
  }, [formId]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (field, file) => {
    setFileData(prev => ({ ...prev, [field]: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = new FormData();
    Object.keys(formData).forEach(key => {
      payload.append(key, formData[key]);
    });
    Object.keys(fileData).forEach(key => {
      if (fileData[key]) {
        payload.append(key, fileData[key]);
      }
    });
    if (userId) {
      payload.append('user_id', userId);
    } else {
      console.warn("⚠️ Warning: No user_id found in URL query parameters!");
    }
    console.log('Form ID being submitted:', formId);
    console.log('User ID being submitted:', userId);

    try {
      const res = await axios.post(
        `${API_BASE}/public/form/${formId}/submit`,
        payload
      );

      console.log('Submit response:', res.data);

      if (res.data.success) {
        setSubmitted(true);
      } else {
        alert(res.data.message || 'Form submission failed.');
      }
    } catch (err) {
      console.error('Form submission error:', err);
      alert('Form submission failed. Please check inputs and try again.');
    }
  };

  if (loading) {
    return (
      <div style={{ backgroundColor: '#f1f5f9', color: '#475569', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
        Loading official form portal...
      </div>
    );
  }

  if (errorMsg) {
    return (
      <div style={{ backgroundColor: '#f1f5f9', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', padding: '32px', borderRadius: '6px', textAlign: 'center', maxWidth: '450px', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <div style={{ color: '#dc2626', marginBottom: '12px' }}>
            <AlertCircle size={32} style={{ margin: '0 auto' }} />
          </div>
          <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#1e293b', margin: '0 0 8px' }}>Service Unavailable</h2>
          <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>{errorMsg}</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div style={{ backgroundColor: '#f1f5f9', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', padding: '40px 32px', borderRadius: '6px', textAlign: 'center', maxWidth: '480px', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <div style={{ color: '#16a34a', marginBottom: '12px' }}>
            <CheckCircle2 size={38} style={{ margin: '0 auto' }} />
          </div>
          <h2 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1e293b', margin: '0 0 8px' }}>Submission Successful</h2>
          <p style={{ fontSize: '13px', color: '#64748b', margin: 0, lineHeight: '1.5' }}>
            Your response has been securely registered in the central database system.
          </p>
        </div>
      </div>
    );
  }

  // ============================================================
  // MAIN FORM UI
  // ============================================================
  return (
    <div style={{ backgroundColor: '#f1f5f9', color: '#1e293b', minHeight: '100vh', padding: '30px 16px', fontFamily: 'Arial, Helvetica, sans-serif' }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', backgroundColor: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '8px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ backgroundColor: '#1e3a8a', color: '#ffffff', padding: '20px 24px', borderBottom: '4px solid #f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <ShieldCheck size={16} color="#f59e0b" />
              <span style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 'bold', color: '#93c5fd' }}>Official Online Submission Portal</span>
            </div>
            <h1 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>{formTitle}</h1>
            <p style={{ fontSize: '12px', color: '#cbd5e1', margin: '6px 0 0' }}>Fields marked with an asterisk (<span style={{ color: '#f87171' }}>*</span>) are mandatory.</p>
          </div>
          <div style={{ backgroundColor: '#ffffff', padding: '6px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', flexShrink: 0 }}>
            <img src={logoImage} alt="Portal Logo" style={{ height: '48px', width: 'auto', display: 'block', objectFit: 'contain' }} />
          </div>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit} style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {formSchema.map((field) => {
            const fieldNameLower = field.Field.toLowerCase();
            const isImage = fieldNameLower.includes('image') || fieldNameLower.includes('photo') || fieldNameLower.includes('pic') || fieldNameLower.includes('profile');
            const isDistrict = fieldNameLower.includes('district');

            return (
              <div key={field.Field} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label style={{ color: '#0f172a', fontSize: '13px', fontWeight: 'bold', textAlign: 'left' }}>
                  {field.Field}
                  {field.Null === 'NO' && <span style={{ color: '#dc2626', marginLeft: '2px' }}>*</span>}
                </label>

                {isImage ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <input type="file" accept="image/*" required={field.Null === 'NO'} onChange={(e) => handleFileChange(field.Field, e.target.files[0])} mstyle={{ color: '#334155', fontSize: '13px', padding: '8px', border: '1px solid #94a3b8', borderRadius: '4px', backgroundColor: '#f8fafc', cursor: 'pointer', width: '100%', boxSizing: 'border-box' }} />
                    <span style={{ fontSize: '11px', color: '#64748b' }}>Allowed formats: JPG, PNG, JPEG</span>
                  </div>
                ) : isDistrict ? (
                  <select required={field.Null === 'NO'} onChange={(e) => handleInputChange(field.Field, e.target.value)} style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid #94a3b8', color: '#0f172a', padding: '9px 12px', borderRadius: '4px', boxSizing: 'border-box', fontSize: '13px' }}>
                    <option value="">-- Select District --</option>
                    {districtsList.map((d, index) => (
                      <option key={index} value={d.district_name}>{d.district_name}</option>
                    ))}
                  </select>
                ) : field.Type.toLowerCase().includes('text') ? (
                  <textarea required={field.Null === 'NO'} placeholder={`Enter details for ${field.Field.toLowerCase()}...`} onChange={(e) => handleInputChange(field.Field, e.target.value)} style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid #94a3b8', color: '#0f172a', padding: '10px 12px', borderRadius: '4px', minHeight: '90px', boxSizing: 'border-box', fontSize: '13px' }} />
                ) : (
                  <input type={field.Type.toLowerCase().includes('int') ? 'number' : field.Type.toLowerCase().includes('date') ? 'date' : 'text'} required={field.Null === 'NO'} placeholder={`Enter ${field.Field.toLowerCase()}...`} onChange={(e) => handleInputChange(field.Field, e.target.value)} style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid #94a3b8', color: '#0f172a', padding: '9px 12px', borderRadius: '4px', boxSizing: 'border-box', fontSize: '13px' }} />
                )}
              </div>
            );
          })}

          {/* Submit Button */}
          <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '16px', display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
            <button mtype="submit" style={{ backgroundColor: '#1e3a8a', color: '#ffffff', border: 'none', padding: '10px 24px', borderRadius: '4px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', textTransform: 'uppercase' }}>Submit Application</button>
          </div>
        </form>
      </div>
    </div>
  );
}